const regex = /^[\u4e00-\u9fa5]+$/;
const getMessage = '請輸入中文';
const validate = (value) => regex.test(value);

/** 只能輸入中文 */
export default {
  getMessage,
  validate,
};
